<template>
    <div
        v-if="quantity"
        class="mqc_product_notification mqc_single_product_notification"
    >
        {{ $t("algoliaSearch.mqc.max") }} {{ quantity }} {{ $t("algoliaSearch.mqc.perCustomer") }}
    </div>
</template>

<script setup>

import { onMounted, ref } from "vue";

const quantity = ref(null);

const props = defineProps({
    productAttributeId: {
        type: Number,
        required: false,
    },
});

const getMaxQuantity = () => {
    // variable is set on the following smarty template: web/themes/brekz-2017/modules/mqc/views/templates/hook/productActions.tpl
    if (typeof product_page_mqc_attributes !== "undefined" && typeof  product_page_mqc_attributes === 'object' && product_page_mqc_attributes && props.productAttributeId) {
        if (product_page_mqc_attributes[props.productAttributeId]) {
            return product_page_mqc_attributes[props.productAttributeId];
        }

        return null;
    }

    return null;
};

onMounted(() => {
    quantity.value = getMaxQuantity();

});

</script>
